import dynamic from "next/dynamic";

export const DynamicContent079 = dynamic(() => import("./Content079"), {
  suspense: true,
});
